import { defineStore } from 'pinia';
import { watch } from 'vue';
import { useState } from '@/composable/useState';
import { Api } from '@/core/lib/api';
import { i18n } from '@/core/lib/i18n';
import type { IBet } from '@/interface/IFantasySelectionMyBets';

export const useFantasySelectionSettledBetsStore = defineStore('FantasySelectionSettledBets', () => {
    const [date, setDate] = useState('');
    const [isLoaded, setIsLoaded] = useState(false);
    const [settledBets, setSettledBets] = useState<IBet[]>([]);

    const refreshSettledBets = async () => {
        try {
            const data = await Api.getFantasySelectionSettledBetList(date.value);
            setSettledBets(data);
            setIsLoaded(true);
        } catch (error) {
            console.error(error);
        }
    };

    watch(i18n.platformLanguageCookie, () => {
        refreshSettledBets();
    });

    watch(date, () => {
        refreshSettledBets();
    });

    return {
        date,
        setDate,
        isLoaded,
        settledBets,
    };
});
